import Alert from './Alert';
import { useToastStore } from '../../stores/toast.store';

/**
 * Montar una sola vez, por fuera del Router (ver App.jsx), para que el toast
 * no se pierda cuando una página navega justo después de mostrarlo.
 */
export default function ToastHost() {
  const toast = useToastStore((s) => s.toast);
  const hideToast = useToastStore((s) => s.hideToast);

  if (!toast) return null;

  return (
    <Alert
      key={toast.key}
      description={toast.description}
      variant={toast.variant}
      autoHideMs={toast.variant === 'error' ? 5000 : 3000}
      onClose={hideToast}
    />
  );
}
